const SET_STORAGE = (key: string, value: string) => {
  const valid = GET_STORAGE(key)
  if (valid) {
    REMOVE_DATA_STORE(key)
    localStorage.setItem(key, value)
  } else {
    localStorage.setItem(key, value)
  }
}

const GET_STORAGE = (key: string) => {
  return localStorage.getItem(key)
}

const REMOVE_DATA_STORE = (key: string) => {
  localStorage.removeItem(key)
}

const CLEAR_STORE = () => {
  localStorage.clear()
}

export { SET_STORAGE, GET_STORAGE, REMOVE_DATA_STORE, CLEAR_STORE }
